import { useTranslation } from "@bounce/i18n"
import type { HowItWorksProps } from "@bounce/web-components"

import trafficIllo from "@bounce/assets/illustrations/friends@2x.webp"
import flexibleIllo from "@bounce/assets/illustrations/phone-ui-01@2x.webp"
import revenueIllo from "@bounce/assets/illustrations/piggy-bank@2x.webp"

export const useBenefits = (): HowItWorksProps["steps"] => {
  const { t } = useTranslation("marketing-partner")

  return [
    {
      src: trafficIllo,
      title: t("cmp.partner.benefit.first.titleV2", "Extra traffic"),
      description: t(
        "cmp.partner.benefit.first.description",
        "We send both locals and tourists your way. Build meaningful relationships with your customers, by providing them with something truly personal.",
      ),
    },
    {
      src: revenueIllo,
      title: t("cmp.partner.benefit.second.titleV2", "Extra revenue"),
      description: t(
        "cmp.partner.benefit.second.description",
        "You earn on every item you store through our platform. Payments are automatically paid out at the end of the month.",
      ),
    },
    {
      src: flexibleIllo,
      title: t("cmp.partner.benefit.third.titleV2", "Extra flexible"),
      description: t(
        "cmp.partner.benefit.third.description",
        "Everything is handled through our online platform. You control your capacity and your opening hours. We let you know when customers are coming by both email and sms.",
      ),
    },
  ]
}
